import React, { useState, useEffect } from "react";
import ArticlesGridContainer from "../../Shared/ArticlesGridContainer";
import ArticlesHybridContainer from "../../Shared/ArticlesHybridContainer";
import ArticlesListContainer from "../../Shared/ArticlesListContainer";
import { IArticlesItem } from "../../interfaces";
import { mapArticlesList } from "../../../../utils";
import { useSelector } from "react-redux";
import { RootState } from "store";

interface IWhnArticlesContainer {
  articles: IArticlesItem[];
  isListView: boolean;
  inEditionSmartSourced?: boolean;
  isCampaign?: boolean;
}

const WhnArticlesContainer: React.FC<IWhnArticlesContainer> = ({
  articles,
  isListView,
  inEditionSmartSourced,
  isCampaign,
}: IWhnArticlesContainer) => {
  const articleSequence: Array<number> = [2, 4, 3, 2];
  const [articleLists, setArticleLists] = useState<Array<Array<IArticlesItem>>>([]);

  //map articles based on articles sequence defined
  const updateArticlesLists = () => {
    let tmpArticleLists = mapArticlesList(articles, articleSequence);
    setArticleLists(tmpArticleLists);
  };

  useEffect(() => {
    //update articles on articles array change
    updateArticlesLists();
  }, [articles]);

  return articles.length === 0 ? null : (
    <div className="">
      {isListView ? (
        <>
          <div className="padding-top-sm padding-bottom-sm list-style">
            <ArticlesListContainer
              isCampaign={isCampaign}
              inEditionSmartSourced={inEditionSmartSourced}
              articles={articles}
            />
          </div>
        </>
      ) : (
        <>
          {typeof articleLists[0] !== "undefined" && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesGridContainer
                isCampaign={isCampaign}
                key="1"
                articles={articleLists[0]}
                imgHeight="230"
                imgWidth="613"
                articleSpan={12}
                top={true}
                inEditionSmartSourced={inEditionSmartSourced}
              />
            </div>
          )}
          {/* third row   */}

          {typeof articleLists[1] !== "undefined" && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesHybridContainer
                isCampaign={isCampaign}
                inEditionSmartSourced={inEditionSmartSourced}
                articles={articleLists[1]}
              />
            </div>
          )}

          {/* fourth row */}
          {typeof articleLists[2] !== "undefined" && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesGridContainer
                isCampaign={isCampaign}
                smallBlog
                key="2"
                articles={articleLists[2]}
                imgHeight="170"
                imgWidth="401"
                articleSpan={8}
                inEditionSmartSourced={inEditionSmartSourced}
              />
            </div>
          )}
          {/* fifth row */}
          {typeof articleLists[3] !== "undefined" && (
            <div className="padding-top-md padding-bottom-md">
              <ArticlesGridContainer
                isCampaign={isCampaign}
                key="3"
                articles={articleLists[3]}
                imgHeight="230"
                imgWidth="613"
                articleSpan={12}
                inEditionSmartSourced={inEditionSmartSourced}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WhnArticlesContainer;
